import { AssetsUserDetailsResolverBase } from './assets-user-details.resolver.base';
import { AssetsUserDetailsService } from './assets-user-details.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class AssetsUserDetailsResolver extends AssetsUserDetailsResolverBase {

  constructor(protected service: AssetsUserDetailsService) {
    super(service);
  }
}



